import React from "react"
import { Link } from "gatsby"
import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import "../../../styles/industry.scss"
import linkedIn from "../../../assets/images/linkedIn.svg"
import messenger from "../../../assets/images/messenger.svg"
import readmoreImg from "../../../assets/images/readmoreImg.svg"
import lucrys from "../../../assets/images/lucrys.png"
import iig from "../../../assets/images/iig.jpg"
import acuteSingleProdImg from "../../../assets/images/single-product-acute-image.png"
import stanzenObj from "../../../assets/images/stanzen-obj.png"
import stanzenSol from "../../../assets/images/stanzen-sol.png"

const Stanzen = () => (
  <Layout>
    <SEO title="Stanzen" />

    <div className="row industry-banner text-center m-0">
      <div className="col-12 white">
        <h5>Automotive Manufacturing Industry</h5>
        <h1>Increase Operational Efficiency.</h1>
      </div>
    </div>

    <br />
    <div className="container">
      <div className="text-center">
        <h3 className="title">Introduction</h3>
        <p>
          Stanzen Engineering increased the operational efficiency of their
          entire plan by 30% using our Industrial IoT Gateways and Lucrys
          Analytics.
        </p>
        <p className="read-more pt-2">
          SStanzen Engineering is one of the leading players in automotive
          stamping and related solutions. In their three decades of operating in
          the industry, they have satisfactorily fulfilled hundreds of projects
          involving body, chassis, assembly, and safety standards. Their range
          of solutions includes pressing, welding, assembling, and tooling.
        </p>
      </div>
      <br />
      <div className="pt-4">
        <h4 className="pt-lg-4 pt-md-2 px-0 mb-lg-0 sub-title">
          Their Objective
        </h4>

        <div className="row m-0 text-left">
          <div className="col-12 col-lg-6 col-md-6 text-center p-0 order-lg-2 order-md-2">
            <div className="industry-img">
              <img src={stanzenObj} className="responsive-img" />
            </div>
          </div>
          <div className="col-12 col-lg-6 col-md-6 pl-0 pr-0 pr-lg-5 pr-md-3 order-lg-1 order-md-1">
            <p className="pt-4 pt-lg-0 pt-md-0 read-more">
              Stanzen Engineering aimed to be able to monitor all the production
              details in real-time. Their machines are from various
              manufacturers and had different legacy-based controllers and
              communication protocols. Due to diverse suppliers and protocols,
              the required information was either scattered over multiple
              platforms or unavailable.
            </p>
          </div>
        </div>
      </div>
      <br />
      <div className="pt-4">
        <h4 className="my-3 my-lg-5 py-3 py-md-2 py-lg-3 title text-center">
          Our Solution
        </h4>

        <div className="row m-0 text-left">
          <div className="col-12 col-lg-6 col-md-6 text-center p-0 order-lg-2 order-md-2">
            <div className="industry-img">
              <img src={stanzenSol} className="responsive-img" />
            </div>
          </div>
          <div className="col-12 col-lg-6 col-md-6 pl-0 pr-0 pr-lg-5 pr-md-3 order-lg-1 order-md-1 order-sm-2">
            <p className="pt-4 pt-lg-0 pt-md-0 read-more">
              They needed one platform that could communicate with machines of
              different makes, controllers, and communication protocols and
              compile all the necessary production details.
            </p>
            <p className="pt-lg-1 read-more">
              The first thing we did was install our industrial IoT gateway,
              which would transmit data from all of their machines. Once we
              finished our 10-minute setup, the platform started collecting data
              immediately. The venue soon started displaying data about the
              device running time and idle time, production efficiency, stroke
              count, pressure, temperature, production forecast, and many more.
            </p>
            <p className="pt-lg-1 read-more">
              Stanzen Engineering wanted to focus specifically on specific
              critical KPIs. We were more than happy to create a report with
              these KPIs for them.
            </p>
            <p className="pt-lg-1 read-more">
              Overall Equipment Effectiveness (OEE) - To ensure their product
              quality is always on point and their machinery performs perfectly
              every time, we created this dashboard. Overall Equipment
              Effectiveness (OEE) is the gold standard for measuring
              manufacturing productivity. It shows as a percentage of the time.
              In short, it indicates the percentage of time a machine has been
              productive out of its total running time. It is divided into three
              parts:
            </p>
            <p className="pt-lg-1 read-more">
              <ol>
                <li>
                  Quality - How often does the machine churn out optimum quality
                  products? Is it producing any defective units? Do any of the
                  teams require rework? A score of 100% indicates that 100% of
                  the time, the machine has optimum quality products..
                </li>
                <li>
                  Performance - How quickly is your machine producing products?
                  Is your machine slowing down? Is your device running
                  optimally? A score of 100% indicates that 100% of the time,
                  the engine is processing products as fast as possible.
                </li>
                <li>
                  Availability - How often do you suffer unplanned shutdowns?
                  Are your machines running as planned? A score of 100%
                  indicates that 100% of the time, your devices and processes
                  are performing during the scheduled production time.
                </li>
              </ol>
            </p>
            <p className="pt-lg-1 read-more">
              Furthermore, their maintenance team provided us with six months of
              machine runtime data. This data showed us the following failures:
            </p>
            <p className="pt-lg-1 read-more">
              <ol>
                <li>Misaligned Shaft</li>
                <li>Bearing Defects </li>
              </ol>
            </p>
            <p className="pt-lg-1 read-more">
              We fed the six months data mentioned above, potential diagnosis,
              and the parameters in our AI algorithm. Additionally, our
              vibration sensors’ data indicated high levels of unusual
              vibrations and high temperatures. Then, our AI algorithm ran a
              correlation analysis between all these data sets, identifying
              patterns, and predicted further bearing defects.
            </p>
            <p className="pt-lg-1 read-more">
              We communicated this piece of information to the maintenance team,
              and upon verification, they confirmed that the parts had worn out.
              We were able to predict bearing wear accurately.
            </p>
            <p className="pt-lg-1 read-more">
              <span className="read-more-sub-title"> Actual vs Planned </span>-
              This data shows the comparison between planned production and
              actual production. We have presented the expected information and
              the real data, shift-wise as well as week-wise. This segregation
              has been done to provide deeper insights to the users.
            </p>
            <p className="pt-lg-1 read-more">
              <span className="read-more-sub-title"> Production Forecast </span>{" "}
              - Additionally, our predictive AI showed a predictive analysis of
              their machine health. This information included the number of days
              until each of the components of a machine would fail, their
              maintenance priority, and vibration levels (whether it’s normal or
              abnormal).
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className="m-0 py-5">
      <div className="pb-lg-5 results-div">
        <div className="text-center">
          <h2 className="title">Results</h2>
          <h3 className="col-lg-8 offset-lg-2 col-md-10 offset-md-1">
            By being able to monitor comprehensive production details in
            real-time, they were able to increase the operational efficiency of
            their entire plant by 30%, achieve production targets and
            successfully predict machine failures and save unnecessary costs.
          </h3>
        </div>
        <div className="container">
          <div className="px-0 pt-3 pt-lg-5 pb-3 pb-md-5 pt-md-4 col-lg-5 col-md-4 results-desc">
            <p className="read-more text-left">
              And that’s not all. When the management compared the amount
              invested in our products and their savings in downtime costs, they
              found the ROI to be ten times their investment in Machstatz!
            </p>
            <p className="read-more text-left">
              This way, we accurately predicted what component caused the
              recurring shutdowns, but we also identified why the part failed
              frequently. We removed costly guesswork and replaced it with an
              intelligent system that consistently warns them about imminent
              issues.
            </p>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div className="container mt-5 mb-5">
      <h4 className="text-center title">Products Used</h4>
      <div className="row text-center pt-3 pt-lg-5 pb-3 pb-lg-5 mx-0">
        <div className="col-12 col-lg-6 p-0 pr-md-3">
          <div className="w-100 prod-div d-flex flex-column">
            <Link
              to="/integrated-industrialized-gateways"
              className="flex-fill"
            >
              {/* <div className="prod-image-wrapper"> */}
              <div className="prod-img">
                <img src={iig} className="responsive-img h-100" />
              </div>
              {/* </div> */}
            </Link>
            <h3 className="text-center sub-title-prod">
              Integratred Industrial Gateway
            </h3>
          </div>
        </div>
        <div className="col-12 col-lg-6 p-0 pl-lg-3 mt-5 mt-lg-0">
          <div className="prod-div d-flex flex-column">
            <Link to="/lucrys-analytics" className="flex-fill">
              {/* <div className="prod-image-wrapper"> */}
              <div className="prod-img">
                <img src={lucrys} className="responsive-img h-100" />
              </div>
              {/* </div> */}
            </Link>
            <h3 className="text-center sub-title-prod">Lucrys Analytics</h3>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div className="row m-0">
      <div className="sol-div col-lg-12 col-md-12 text-center">
        <h4 className="bold sub-title">Solution Used</h4>
        <img className="industry-soln" src={acuteSingleProdImg} />
        <h4 className="bold sub-title" style={{ fontFamily: "Avenir Roman" }}>
          Acute
        </h4>
      </div>
    </div>
    <br />
    <div className="container">
      {/* <div className="text-center d-flex blog-share pl-lg-3 px-lg-3">
                <span className="font-14 bold blog-share-text order-md-3 py-2 py-md-0">
                    Don't forget to share this post!
            </span>
                <div className="blog-share-icons">
                    <i className="fab fa-facebook-f share-icon"></i>
                    <i className="fab fa-linkedin-in share-icon"></i>
                    <i className="fab fa-twitter share-icon"></i>
                    <i className="fab fa-facebook-messenger"></i>
                </div>
                <span className="font-25 flex-fill px-1 d-none d-md-block">
                    <span className="blog-dashed-lines"></span>
                </span>
            </div> */}
      <div className="d-flex align-items-center flex-wrap">
        <div className="order-md-3 share-request-text-for-particular">
          <p className="pl-md-2 m-0 text-center">
            Don't forget to share this post!
          </p>
        </div>
        <div className="share-icons pr-md-2 text-center mt-3 mt-lg-0 mt-md-0">
          <a
            className="share-icon"
            target="_blank"
            href="https://www.facebook.com/sharer/sharer.php?u=https://machstatz.com/stanzen"
          >
            <img
              className="icons-for-particular"
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUgMUMxMS42ODYzIDEgOSAzLjY4NjI5IDkgN1Y5SDdDNi40NDc3MiA5IDYgOS40NDc3MSA2IDEwVjE0QzYgMTQuNTUyMyA2LjQ0NzcyIDE1IDcgMTVIOVYyMkM5IDIyLjU1MjMgOS40NDc3MiAyMyAxMCAyM0gxNEMxNC41NTIzIDIzIDE1IDIyLjU1MjMgMTUgMjJWMTVIMTdDMTcuNDU4OSAxNSAxNy44NTg5IDE0LjY4NzcgMTcuOTcwMSAxNC4yNDI1TDE4Ljk3MDEgMTAuMjQyNUMxOS4xMjc5IDkuNjExMzkgMTguNjUwNiA5IDE4IDlIMTVWN0gxOEMxOC41NTIzIDcgMTkgNi41NTIyOCAxOSA2VjJDMTkgMS40NDc3MiAxOC41NTIzIDEgMTggMUgxNVpNMTUgM0gxN1Y1SDE1QzEzLjg5NTQgNSAxMyA1Ljg5NTQzIDEzIDdWMTBDMTMgMTAuNTUyMyAxMy40NDc3IDExIDE0IDExSDE2LjcxOTJMMTYuMjE5MiAxM0gxNEMxMy40NDc3IDEzIDEzIDEzLjQ0NzcgMTMgMTRWMjFIMTFWMTRDMTEgMTMuNDQ3NyAxMC41NTIzIDEzIDEwIDEzSDhWMTFIMTBDMTAuNTUyMyAxMSAxMSAxMC41NTIzIDExIDEwVjdDMTEgNC43OTA4NiAxMi43OTA5IDMgMTUgM1oiIGZpbGw9ImJsYWNrIi8+DQo8bWFzayBpZD0ibWFzazAiIG1hc2stdHlwZT0iYWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjYiIHk9IjEiIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMiI+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDFDMTEuNjg2MyAxIDkgMy42ODYyOSA5IDdWOUg3QzYuNDQ3NzIgOSA2IDkuNDQ3NzEgNiAxMFYxNEM2IDE0LjU1MjMgNi40NDc3MiAxNSA3IDE1SDlWMjJDOSAyMi41NTIzIDkuNDQ3NzIgMjMgMTAgMjNIMTRDMTQuNTUyMyAyMyAxNSAyMi41NTIzIDE1IDIyVjE1SDE3QzE3LjQ1ODkgMTUgMTcuODU4OSAxNC42ODc3IDE3Ljk3MDEgMTQuMjQyNUwxOC45NzAxIDEwLjI0MjVDMTkuMTI3OSA5LjYxMTM5IDE4LjY1MDYgOSAxOCA5SDE1VjdIMThDMTguNTUyMyA3IDE5IDYuNTUyMjggMTkgNlYyQzE5IDEuNDQ3NzIgMTguNTUyMyAxIDE4IDFIMTVaTTE1IDNIMTdWNUgxNUMxMy44OTU0IDUgMTMgNS44OTU0MyAxMyA3VjEwQzEzIDEwLjU1MjMgMTMuNDQ3NyAxMSAxNCAxMUgxNi43MTkyTDE2LjIxOTIgMTNIMTRDMTMuNDQ3NyAxMyAxMyAxMy40NDc3IDEzIDE0VjIxSDExVjE0QzExIDEzLjQ0NzcgMTAuNTUyMyAxMyAxMCAxM0g4VjExSDEwQzEwLjU1MjMgMTEgMTEgMTAuNTUyMyAxMSAxMFY3QzExIDQuNzkwODYgMTIuNzkwOSAzIDE1IDNaIiBmaWxsPSJ3aGl0ZSIvPg0KPC9tYXNrPg0KPGcgbWFzaz0idXJsKCNtYXNrMCkiPg0KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJibGFjayIvPg0KPC9nPg0KPC9zdmc+DQo="
            ></img>
          </a>
          <a
            className="share-icon"
            target="_blank"
            href="https://www.linkedin.com/shareArticle?mini=true&url=https://machstatz.com/stanzen&title=Stanzen Engineering Industrial IoT Gateways and Lucrys Analytics.&source=Stanzen Engineering with Machstatz"
          >
            <img className="icons-for-particular" src={linkedIn}></img>
          </a>
          <a
            className="share-icon"
            target="_blank"
            href="https://twitter.com/intent/tweet?text=https://machstatz.com/stanzen"
          >
            <img
              className="icons-for-particular"
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjMuOTczNiAzLjI0NjkzQzI0LjE5MjIgMi4zNDkxOSAyMy4xODA2IDEuNjYwNTYgMjIuNDI1NiAyLjE5MzE1QzIxLjcxNzIgMi42OTI4NCAyMC45NDY5IDMuMDk2ODMgMjAuMTM0OCAzLjM5NTM1QzE4LjYyMTYgMi4wNDExMSAxNi40NTk5IDEuNjIyOTUgMTQuNTI3NSAyLjM2MDVDMTIuMzkwNyAzLjE3NjA4IDEwLjk4NjQgNS4yMzIyNyAxMS4wMDE3IDcuNTE2ODFDOC4xMzQ5OCA3LjMwMTcxIDUuNDkxOTUgNS44MTU4NSAzLjgyMDM2IDMuNDM1NkMzLjM3MzY3IDIuNzk5NTMgMi40MDM4NyAyLjg5MzkxIDIuMDg4MiAzLjYwNDE3QzEuOTU3OTIgMy44OTcyOCAxLjc3NDU2IDQuMzk3MDMgMS41OTQxNiA1LjA2MDI4QzAuOTk3NzcgNy4yNTI4OCAwLjg5MzQyNSA5LjU2MTU4IDEuNjA4MyAxMS43NTg1QzIuMzAwNjcgMTMuODg2MyAzLjcxMjAyIDE1LjY4NDkgNS45MTYxNiAxNy4wNDM1QzQuMzk3OTUgMTcuNzQyOSAyLjcyODM1IDE4LjA3ODIgMS4wNDE3NSAxOC4wMTExQy0wLjAxMDYzODkgMTcuOTY5MiAtMC40MDQzMTggMTkuMzczIDAuNTE2MzY0IDE5Ljg4NDVDMTAuNTU1OSAyNS40NjIgMjIuMDAyIDE5LjM2OTcgMjIuMDAyIDcuNTEwMzFDMjIuMDAxNSA3LjM0NjMzIDIxLjk5MzcgNy4xODMzIDIxLjk3ODkgNy4wMjEzMkMyMi45NDQ0IDUuOTQ5OTEgMjMuNjMxMSA0LjY1MzQ3IDIzLjk3MzYgMy4yNDY5M1pNMTkuMTA3NSA1LjE5NjU1QzE5LjM2NTYgNS40OTMzNCAxOS43NzM3IDUuNjExMjUgMjAuMTUwMyA1LjQ5Nzg0QzIwLjM4MiA1LjQyODA5IDIwLjYxMTIgNS4zNTEzNiAyMC44Mzc3IDUuMjY3ODFDMjAuNjQ4OSA1LjUxNDQ3IDIwLjQ0MjYgNS43NDg2MiAyMC4yMTk4IDUuOTY4M0MxOS45ODIyIDYuMjAyNjkgMTkuODc3MSA2LjU0MDIgMTkuOTM5OCA2Ljg2ODA2QzE5Ljk4MDUgNy4wODA4NSAyMC4wMDEzIDcuMjk2OTcgMjAuMDAyIDcuNTEzNjFDMjAuMDAyIDE2LjQ1NjUgMTIuNjEzMiAyMS41NTQzIDQuOTM0MDEgMTkuNTM0MUM2LjIxODMyIDE5LjE2NzUgNy40NDQ1MyAxOC41OTczIDguNTYzNjQgMTcuODM3N0M5LjIxMjYxIDE3LjM5NzIgOS4xMjQ5MSAxNi40MTUxIDguNDA4MTQgMTYuMDk2NUM1LjczNzAyIDE0LjkwOTMgNC4xODcxNyAxMy4yMjAzIDMuNTEwMTUgMTEuMTM5N0MyLjk4MjE1IDkuNTE3MDMgMy4wMTEwMyA3Ljc1ODY2IDMuNDA2MDcgNi4wNTM1N0M1LjY1MTk2IDguMzQwOTQgOC43NjcxOSA5LjYyNDUyIDEyLjAyNzkgOS41Mzk5N0MxMi41Njk5IDkuNTI1OTIgMTMuMDAyIDkuMDgyNSAxMy4wMDIgOC41NDAzMVY3LjU0MDMxQzEyLjk4MjMgNi4wNjY3OCAxMy44NzY0IDQuNzQ5NzMgMTUuMjQwNyA0LjIyOTAyQzE2LjYwNDkgMy43MDgzMSAxOC4xNDkyIDQuMDk0NzEgMTkuMTA3NSA1LjE5NjU1WiIgZmlsbD0iYmxhY2siLz4NCjxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMiIgd2lkdGg9IjI1IiBoZWlnaHQ9IjIwIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjMuOTczNiAzLjI0NjkzQzI0LjE5MjIgMi4zNDkxOSAyMy4xODA2IDEuNjYwNTYgMjIuNDI1NiAyLjE5MzE1QzIxLjcxNzIgMi42OTI4NCAyMC45NDY5IDMuMDk2ODMgMjAuMTM0OCAzLjM5NTM1QzE4LjYyMTYgMi4wNDExMSAxNi40NTk5IDEuNjIyOTUgMTQuNTI3NSAyLjM2MDVDMTIuMzkwNyAzLjE3NjA4IDEwLjk4NjQgNS4yMzIyNyAxMS4wMDE3IDcuNTE2ODFDOC4xMzQ5OCA3LjMwMTcxIDUuNDkxOTUgNS44MTU4NSAzLjgyMDM2IDMuNDM1NkMzLjM3MzY3IDIuNzk5NTMgMi40MDM4NyAyLjg5MzkxIDIuMDg4MiAzLjYwNDE3QzEuOTU3OTIgMy44OTcyOCAxLjc3NDU2IDQuMzk3MDMgMS41OTQxNiA1LjA2MDI4QzAuOTk3NzcgNy4yNTI4OCAwLjg5MzQyNSA5LjU2MTU4IDEuNjA4MyAxMS43NTg1QzIuMzAwNjcgMTMuODg2MyAzLjcxMjAyIDE1LjY4NDkgNS45MTYxNiAxNy4wNDM1QzQuMzk3OTUgMTcuNzQyOSAyLjcyODM1IDE4LjA3ODIgMS4wNDE3NSAxOC4wMTExQy0wLjAxMDYzODkgMTcuOTY5MiAtMC40MDQzMTggMTkuMzczIDAuNTE2MzY0IDE5Ljg4NDVDMTAuNTU1OSAyNS40NjIgMjIuMDAyIDE5LjM2OTcgMjIuMDAyIDcuNTEwMzFDMjIuMDAxNSA3LjM0NjMzIDIxLjk5MzcgNy4xODMzIDIxLjk3ODkgNy4wMjEzMkMyMi45NDQ0IDUuOTQ5OTEgMjMuNjMxMSA0LjY1MzQ3IDIzLjk3MzYgMy4yNDY5M1pNMTkuMTA3NSA1LjE5NjU1QzE5LjM2NTYgNS40OTMzNCAxOS43NzM3IDUuNjExMjUgMjAuMTUwMyA1LjQ5Nzg0QzIwLjM4MiA1LjQyODA5IDIwLjYxMTIgNS4zNTEzNiAyMC44Mzc3IDUuMjY3ODFDMjAuNjQ4OSA1LjUxNDQ3IDIwLjQ0MjYgNS43NDg2MiAyMC4yMTk4IDUuOTY4M0MxOS45ODIyIDYuMjAyNjkgMTkuODc3MSA2LjU0MDIgMTkuOTM5OCA2Ljg2ODA2QzE5Ljk4MDUgNy4wODA4NSAyMC4wMDEzIDcuMjk2OTcgMjAuMDAyIDcuNTEzNjFDMjAuMDAyIDE2LjQ1NjUgMTIuNjEzMiAyMS41NTQzIDQuOTM0MDEgMTkuNTM0MUM2LjIxODMyIDE5LjE2NzUgNy40NDQ1MyAxOC41OTczIDguNTYzNjQgMTcuODM3N0M5LjIxMjYxIDE3LjM5NzIgOS4xMjQ5MSAxNi40MTUxIDguNDA4MTQgMTYuMDk2NUM1LjczNzAyIDE0LjkwOTMgNC4xODcxNyAxMy4yMjAzIDMuNTEwMTUgMTEuMTM5N0MyLjk4MjE1IDkuNTE3MDMgMy4wMTEwMyA3Ljc1ODY2IDMuNDA2MDcgNi4wNTM1N0M1LjY1MTk2IDguMzQwOTQgOC43NjcxOSA5LjYyNDUyIDEyLjAyNzkgOS41Mzk5N0MxMi41Njk5IDkuNTI1OTIgMTMuMDAyIDkuMDgyNSAxMy4wMDIgOC41NDAzMVY3LjU0MDMxQzEyLjk4MjMgNi4wNjY3OCAxMy44NzY0IDQuNzQ5NzMgMTUuMjQwNyA0LjIyOTAyQzE2LjYwNDkgMy43MDgzMSAxOC4xNDkyIDQuMDk0NzEgMTkuMTA3NSA1LjE5NjU1WiIgZmlsbD0id2hpdGUiLz4NCjwvbWFzaz4NCjxnIG1hc2s9InVybCgjbWFzazApIj4NCjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iYmxhY2siLz4NCjwvZz4NCjwvc3ZnPg0K"
            ></img>
          </a>
          {/* <a className="share-icon" target="_blank" href="https://www.messenger.com/machstatz/">
                        <img className="icons" src={messenger}></img>
                    </a> */}
        </div>
        <div className="share-dashes d-none d-md-block"></div>
      </div>
      <br />
      <div className="industry-scroller row pt-3 pt-lg-5 ml-0">
        <div className="col-12 col-lg-6 col-md-6">
          <div className="pl-3 p-md-0">
            <div className="speech-bubble-story-1">
              <p className="questions">
                A Chemical Manufacturing Plant successfully predicted and
                prevented 12 hours of machine downtime using pattern recognition
                and AI (a 10x ROI!)
              </p>
              <Link to="/case-studies/kmml">
                <p className="pl-4 d-flex">
                  <img className="icons" src={readmoreImg}></img>
                  <p className="read-more-speech pl-2 float-l">Read more</p>
                </p>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 offset-lg-0 col-md-6 pl-0 pl-md-5">
          <div className="p-md-0">
            <div className="speech-bubble-story-2">
              <p className="questions">
                Jindal Steel & Power Limited used our Lucrys Analytics Platform
                to connect their machines, track and improve the deviations in
                the manufacturing process on real time basis.
              </p>
              <Link to="/case-studies/jspl">
                <p className="pl-4 d-flex">
                  <img className="icons" src={readmoreImg}></img>
                  <p className="read-more-speech pl-2 float-l">Read more</p>
                </p>
              </Link>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-4 col-md-12">
                    <div className="p-md-0 text-center">
                        <div className=" speech-bubble-industry-3">
                            <p className="questions font-12 p-0">
                                text unknown text unknown text unknown text unknown text unknown text unknowntext unknown text
                    </p>
                            <p className="p-0 d-none d-lg-block">
                                <i className="fas fa-arrow-circle-right read-more float-l">Read more</i>
                            </p>
                        </div>
                    </div>
                </div> */}
      </div>
    </div>
  </Layout>
)

export default Stanzen
